<template>
  <div class="">
    <div class="">
      <div>
        <h2>污染物(经气象调整后)降幅及综合改善情况</h2>
      </div>

      <div style="text-align: left">
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <span style="color: #f56c6c"
                >什么是气象调整方法？<i class="header-icon el-icon-info"></i
              ></span>
            </template>
            <div>
              基于2011年3月到2019年2月累积八年的小时气象数据，对“2+66”城市分别构造基准气象条件，在此基准气象条件下计算各季节污染物的浓度，通过控制气象条件，捕捉潜在排放量的变化。具体来说，我们采用核估计方法，对各年份和季度的污染与气象数据建立调整模型，将该模型作用于八年基准气象的经验分布函数，计算调整均值。
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <span style="color: #f56c6c"
                >综合改善情况？<i class="header-icon el-icon-info"></i
              ></span>
            </template>
            <div>去除气象因素后六种污染物累积降幅的均值即为综合改善情况。</div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <el-form class="textAlignLeft">
        <el-form-item label="评估污染物" class="marginZero">
          <el-radio-group v-model="assessPull" @change="pullChange">
            <el-radio label="PM2.5">PM2.5</el-radio>
            <el-radio label="PM10">PM10</el-radio>
            <el-radio label="SO2">SO2</el-radio>
            <el-radio label="NO2">NO2</el-radio>
            <el-radio label="CO">CO</el-radio>
            <el-radio label="O3">O3</el-radio>
            <el-radio label="avg">综合改善情况</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="评估类型" class="marginZero">
          <el-radio-group v-model="assessPullType" @change="pullChange">
            <el-radio label="reduce_total" :disabled="assessPull == 'avg'"
              >累积降幅</el-radio
            >
            <el-radio label="reduce_avg" :disabled="assessPull == 'avg'"
              >年降幅平均</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>

    <!-- 图像下载 -->
    <div>
      <el-row type="flex" justify="end">
        <el-button
          type="success"
          icon="el-icon-download"
          @click="downloadImage"
          :loading="imageDownloading"
          >图像下载</el-button
        >
      </el-row>
    </div>

    <div class="content-body" id="area-pull-reduce-chart-canvas">
      <div
        id="area-pull-reduce-chart"
        :style="{ height: eleheight + 'px', paddingRight: 1 + 'px' }"
      ></div>
    </div>
  </div>
</template>

<style scoped>
.el-row {
  margin-bottom: 15px;
}
</style>

<script>
import { GenerateMapImgFromDom } from "@/assets/js/utils-map.js";

export default {
  name: "Platform",
  data() {
    return {
      cityname: ["北京"],
      eleheight: 400,
      chart: [],
      assessYear: "2019",
      assessSeason: 1,
      assessPull: "PM2.5",
      assessPullType: "reduce_total",
      Seasons: [
        {
          name: "春季",
          value: 1,
        },
        {
          name: "夏季",
          value: 2,
        },
        {
          name: "秋季",
          value: 3,
        },
        {
          name: "冬季",
          value: 4,
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > 2019 || time.getFullYear() < 2013;
        },
      },
    };
  },
  computed: {},
  methods: {
    downloadImage() {
      let imageDom = document.getElementById("area-pull-reduce-chart-canvas");

      let pull = this.assessPull;
      let seasonZh = ["全年平均", "春季", "夏季", "秋季", "冬季"];

      if (pull == "avg") {
        pull = "综合改善情况";
      } else {
        if (this.assessPullType == "reduce_total") {
          pull = pull + "累积降幅";
        } else {
          pull = pull + "年降幅平均";
        }
      }

      let title =
        this.year_s +
        "年-" +
        this.year_e +
        "年" +
        "各城市" +
        pull +
        "及排名变化";

      GenerateMapImgFromDom(imageDom, title + ".png");
    },

    assessYearChange() {
      this.assessYear = this.assessYear.getFullYear() + "";
      this.updateCharts();
    },
    pullChange() {
      this.updateCharts();
    },
    updateCharts() {
      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.getAreaReduceData();
    },
    getAreaReduceData() {
      const that = this;

      let url = "/AQAssess/getAreaReduce/" + this.assessPull + "/" + this.assessPullType;

      this.$axios
        .get(url)
        .then((res) => {
          that.pulldata = [];
          let nationAvg = 0;
          let year_s = 9999;
          let year_e = 0;
          res.data.forEach((element) => {
            that.assesscity.forEach((city_elm) => {
              if (city_elm[1] == element[0]) {
                that.pulldata.push(element);
              }
            });
            nationAvg += parseFloat(element[3]);

            year_s = element[1] < year_s ? element[1] : year_s;
            year_e = element[2] > year_e ? element[2] : year_e;
          });
          nationAvg = (100 * nationAvg) / res.data.length;

          that.year_s = year_s;
          that.year_e = year_e;
          that.drawAreaReduceChart(
            that.chart[0],
            that.pulldata,
            that.assessPull,
            year_s,
            year_e,
            nationAvg,
            that.assessPullType
          );
        });
    },

    drawAreaReduceChart(
      chart,
      data,
      pull,
      year_s,
      year_e,
      nationAvg,
      assessPullType
    ) {
      let rank_data = [];
      let value_data = [];
      data.forEach((item, idx) => {
        rank_data.push([item[0], item[4]]);
        value_data.push([item[0], (100 * item[3]).toFixed(1)]);
      });

      let visualMapTop = 20;

      if (pull == "avg") {
        pull = "综合改善情况";
      } else {
        if (assessPullType == "reduce_total") {
          pull = pull + "累积降幅";
        } else {
          pull = pull + "年降幅平均";
        }
      }

      let visualMapText = ["污染物浓度增加", "污染物浓度降低"];
      let title =
        year_s + "年-" + year_e + "年" + "各城市" + pull + "及排名变化";

      let option = {
        title: {
          text: title,
          left: "center",
          align: "right",
        },
        grid: {
          bottom: 40,
          left: 30,
          right: 30,
          containLabel: true,
        },

        toolbox: {
          feature: {
            // restore: {},
            // saveAsImage: {},
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            animation: false,
            label: {
              backgroundColor: "#505765",
            },
          },

          formatter: function (params) {
            let text = params[0].axisValue + "<br>";
            let intro = "";
            params.forEach((element) => {
              if (element.seriesType == "bar") {
                text += element.marker + "降幅: " + element.value[1] + "%<br>";
                intro =
                  "参与评估的" +
                  data.length +
                  "个城市降幅均值,<br>" +
                  element.axisValue +
                  "市污染物浓度";
                let imp = (parseFloat(element.value[1]) - nationAvg).toFixed(2);
                if (imp > 0) {
                  intro = intro + "增加了" + imp + "%";
                } else {
                  intro = intro + "减少了" + -imp + "%";
                }
              } else {
                text +=
                  element.marker + "降幅排名: " + element.value[1] + "<br>";
              }
            });
            return text + intro;
          },
        },
        legend: {
          left: 10,
        },
        visualMap: [
          {
            show: true,
            seriesIndex: 0,
            type: "piecewise",
            dimension: 1,
            min: -visualMapTop,
            max: visualMapTop,
            text: visualMapText,
            top: 0,
            right: 20,
            orient: "horizontal",
            inRange: {
              color: ["#1E90FF", "#FF0000"],
            },
            pieces: [
              { min: 0 }, // 不指定 max，表示 max 为无限大（Infinity）。
              { max: 0 }, // 不指定 min，表示 min 为无限大（-Infinity）。
            ],
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            right: 55,
            startValue: 0,
            endValue: 24,
          },

          {
            type: "inside",
            xAxisIndex: [0],
            startValue: 0,
            endValue: 24,
          },
        ],
        xAxis: [
          {
            type: "category",
            axisLine: { onZero: false },
          },
        ],
        yAxis: [
          {
            name: "降幅/%",
            type: "value",
            inverse: true,
            nameLocation: "start",
          },
          {
            name: "排名",
            type: "value",
          },
        ],
        series: [
          {
            name: "降幅百分比",
            type: "bar",
            areaStyle: {},
            lineStyle: {
              width: 1,
            },
            label: {
              show: true,
              formatter: function (data) {
                return data.data[1] + "%";
              },
              color: "#F56C6C",
              position: "top",
            },
            data: value_data,
            markLine: {
              data: [
                {
                  yAxis: nationAvg,
                  label: {
                    position: "insideEndTop",
                    formatter: "参与评估的" + data.length + "个城市降幅均值",
                  },
                },
              ],
              lineStyle: {
                color: "#303133",
                type: "solid",
              },
            },
          },
          {
            name: "排名曲线",
            type: "line",
            yAxisIndex: 1,
            // areaStyle: {},
            lineStyle: {
              width: 1,
            },
            data: rank_data,
          },
        ],
      };

      chart.setOption(option);
      chart.hideLoading();
    },
  },
  created() {},
  mounted() {
    if (this.show) {
      this.chart.push(
        this.$echarts.init(document.getElementById("area-pull-reduce-chart"))
      );

      this.updateCharts();
    }

    const that = this;

    window.addEventListener("resize", () => {
      that.chart.forEach((element) => {
        element.resize();
      });
    });
  },
  props: {
    assesscity: {
      type: Array,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return [
          ["直辖市", "北京"],
          ["直辖市", "天津"],
        ];
      },
    },

    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    assesscity: function (newAssesscity, oldAssesscity) {
      this.assesscity = newAssesscity;
      if (this.show) {
        this.updateCharts();
      }
    },

    show: function (newShow, oldShow) {
      this.show = newShow;
      if (this.show) {
        this.chart.forEach((element) => {
          element.dispose();
        });
        this.chart = [];

        this.chart.push(
          this.$echarts.init(document.getElementById("area-pull-reduce-chart"))
        );

        this.updateCharts();
      } else {
        this.chart.forEach((element) => {
          element.clear();
        });
      }
    },
  },
};
</script>
